export const mockInsightsData = {
  brand_health_score: 82,
  visibility_score: 75,
  visibility_trend: [
    { date: '2026-05-01', score: 61 },
    { date: '2026-05-08', score: 64 },
    { date: '2026-05-15', score: 68 },
    { date: '2026-05-22', score: 72 },
    { date: '2026-05-29', score: 75 },
  ],
  competitor_analysis: {
    competitors: 15,
    avg_visibility: 68,
    ranking_position: 3,
  },
  trending_keywords: [
    { keyword: '量化交易策略', volume: 1250, trend: 'up', delta: '+18%' },
    { keyword: '自动化分析工具', volume: 890, trend: 'up', delta: '+12%' },
    { keyword: '市场行情洞察', volume: 2340, trend: 'stable', delta: '+2%' },
    { keyword: 'AI 选股平台', volume: 3100, trend: 'up', delta: '+34%' },
    { keyword: '低费率指数基金', volume: 1680, trend: 'stable', delta: '+1%' },
    { keyword: '交易风险管理', volume: 760, trend: 'down', delta: '-6%' },
  ],
  sentiment_analysis: {
    positive: 78,
    neutral: 15,
    negative: 7,
  },
  ai_model_breakdown: [
    { model: 'ChatGPT', mention_rate: 64, avg_position: 2.8, sentiment: 72 },
    { model: 'Gemini', mention_rate: 57, avg_position: 3.4, sentiment: 68 },
    { model: 'DeepSeek', mention_rate: 48, avg_position: 4.1, sentiment: 65 },
    { model: 'Kimi', mention_rate: 52, avg_position: 3.7, sentiment: 69 },
    { model: 'Doubao', mention_rate: 39, avg_position: 5.2, sentiment: 61 },
    { model: 'Perplexity', mention_rate: 43, avg_position: 4.6, sentiment: 70 },
  ],
  top_opportunities: [
    {
      id: 'opp_1',
      title: '在 DeepSeek 中优化"量化交易"话题可见度',
      impact: 'high',
      effort: 'medium',
      description: 'DeepSeek 对该话题引用率低于竞品 2.3×，补充结构化 FAQ 可快速提升。',
    },
    {
      id: 'opp_2',
      title: '增加"外汇平台对比"长尾词覆盖',
      impact: 'medium',
      effort: 'low',
      description: '该词月搜索量 1,750，当前无可见度，添加对比页可直接进入 AI 答案。',
    },
    {
      id: 'opp_3',
      title: '强化 Kimi 平台的品牌情感',
      impact: 'medium',
      effort: 'medium',
      description: 'Kimi 情感得分 69，低于 ChatGPT 3 分，重点改善用户评价和产品描述。',
    },
  ],
};
